import type { TUser } from '@entities/user/lib/types';
import { useGetUser } from '@entities/user/api/useGetUser';
import { INIT_USER_DATA } from './initData';

export const useUserByIdData = (uuid: TUser['id']): TUser => {
  const { data } = useGetUser(uuid);

  return data || INIT_USER_DATA;
};
